import 'css-chunksrc/client/pages/utilityPage/strategicAxesPage/strategicAxes/styles.scss';export default {
  "strategicAxes": "_strategicAxes_c7jde_1",
  "header": "_header_c7jde_5",
  "label": "_label_c7jde_10",
  "code": "_code_c7jde_20",
  "name": "_name_c7jde_24",
  "col": "_col_c7jde_28",
  "row": "_row_c7jde_35",
  "weight": "_weight_c7jde_43",
  "contextualMenu": "_contextualMenu_c7jde_48"
};